import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Upload {
  nombreArchivo: string;
  GrupoId: string;
  fechaCreacion: Date;
  fechaActualizacion: Date;
  activo: boolean;
  file: File;
}

@Module
export default class UploadModule extends VuexModule {
  errors = {};
  upload = {} as Upload;
  uploads = [] as Array<Upload>;

  /**
   * Get current upload object
   * @returns Upload
   */
  get currentUpload(): Upload {
    return this.upload;
  }

  /**
   * Get errors
   * @returns array
   */
  get getUploadErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_UPLOAD_ERROR](error) {
    this.errors = error;
  }

  @Mutation
  [Mutations.SET_UPLOAD](upload) {
    this.upload = upload;
  }

  @Mutation
  [Mutations.SET_UPLOADS](groups) {
    this.uploads = groups;
  }

  @Action
  [Actions.UPLOAD_FILE](values) {
    return ApiService.postBlob("/Documento/v1/cargar", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_UPLOAD, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_UPLOAD_ERROR, response.data.errors);
        console.log(response);
        throw new Error();
      });
  }

  @Action
  [Actions.GET_UPLOADS]() {
    return ApiService.get(`Documento/v1/documentos/all`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_UPLOADS, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_UPLOAD_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.GET_UPLOADS_ID]() {
    return ApiService.get(`Documento/v1/documentos`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_UPLOADS, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_UPLOAD_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.UPDATE_FILE](params) {
    return ApiService.putBlob(`/Documento/v1/update/documentos`, params)
      .then((data) => {
        this.context.commit(Mutations.SET_UPLOADS, data);
        return { exito: true, data: data };
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_UPLOAD_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.UPDATE_FILE_GRUPO](params) {
    return ApiService.put(`/Documento/v1/update/documentos/grupo`, params)
      .then((data) => {
        this.context.commit(Mutations.SET_UPLOADS, data);
        return { exito: true, data: data };
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_UPLOAD_ERROR, response.data.errors);
        throw new Error();
      });
  }
}
